import API from '@/api/api'

export default {
  // eslint-disable-next-line
  GET_CURRENT_USER ({ state }) {
    let user = state.currentUser
    return API.GET.users.single(user._id)
  },
  // eslint-disable-next-line
  GET_USERS ({}, options) {
    return API.GET.users.all(options)
  },
  // eslint-disable-next-line
  GET_USER ({}, id) {
    return API.GET.users.single(id)
  },
  // eslint-disable-next-line
  GET_USER_DIVISIONS ({}, data){
    data.eventId = this.getters.currentEvent._id
    return API.GET.users.divisions(data)
  },
  // eslint-disable-next-line
  GET_DIVISION ({}, data) {
    data.eventId = this.getters.currentEvent._id
    return API.GET.users.division(data)
  },
  // eslint-disable-next-line
  REQUEST_SUPPORT ({}, data) {
    return API.POST.users.support(data)
  },
  //  UPDATE
  // eslint-disable-next-line
  UPDATE_USER ({ }, data) {
    return API.PUT.users.update(data)
  }
}
